import { BNToNumber } from '@mprolab/sdk'
import { BigNumber } from 'ethers'
import { useState } from 'react'
import { useUSDCContractAddress, useUniswapRouterAddress } from 'state/global/hooks'
import { getUniswapRouterContract } from 'utils/contractHelpers'

export const useGetTokenPrice = () => {
  const uniswapRouterContractAddresses = useUniswapRouterAddress()
  const usdContractAddresses = useUSDCContractAddress()
  const [tokenPriceLoading, setTokenPriceLoading] = useState<boolean>(true)

  const getTokenPrice = async (tokenAddress: string, amount: BigNumber, chainId: number, removeDust?: boolean) => {
    const routerContract = uniswapRouterContractAddresses?.find((contract) => contract.chainId === chainId)
    const usdContract = usdContractAddresses?.find((contract) => contract.chainId === chainId)
    if (!amount || !routerContract?.address || !usdContract?.address) {
      setTokenPriceLoading(false)
      return null
    }
    const router = getUniswapRouterContract(routerContract.address, undefined, chainId)
    try {
      const WETH_CONTRACT_ADDRESS = await router.WETH()
      const USDC_CONTRACT_ADDRESS = usdContract?.address
      const path = [WETH_CONTRACT_ADDRESS, USDC_CONTRACT_ADDRESS]
      if (tokenAddress.toLowerCase() !== WETH_CONTRACT_ADDRESS.toLowerCase()) {
        path.unshift(tokenAddress)
      }

      const amountsOut = await router.getAmountsOut(amount, path)
      const usdcPrice = BNToNumber(amountsOut[path.length - 1], 6)

      if (removeDust && usdcPrice < 0.01) {
        return 0
      }
      return usdcPrice
    } catch (error) {
      return null
    } finally {
      setTokenPriceLoading(false)
    }
  }

  return {
    getTokenPrice,
    tokenPriceLoading
  }
}
